import { environment } from 'src/environments/environment';
import { ViolationBatchProcess } from '../interface/ViolationBatchProcess';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ViolationProcessService {
    constructor(protected http: HttpClient) {}
    public triage(operation: 'accept' | 'refuse', data: ViolationBatchProcess) {
      const url = `${environment.apiUrl}/violation-process/triage/${operation}`;
      return this.http.put(url, data).toPromise();
    }
}
